import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/celtic-woman-2022/sponsors/Eccles-Symphony-ad.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'George S. and Dolores Doré Eccles Foundation',
      class: 'webFormat',
    },
    // {
    //   image: '/celtic-woman-2022/sponsors/arnold.jpg',
    //   link: 'https://www.arnoldmachinery.com',
    //   alt: 'Arnold Machinery Company',
    //   class: 'webFormat',
    // },
    {
      image: '/celtic-woman-2022/sponsors/marketing-1.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'American In Paris',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/marketing-2.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Utah Symphony Social Media',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/education.jpg',
      link: 'https://www.usuo.org/hsclubs',
      alt: 'USUO High School Music Clubs',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/noorda.jpg',
      link: 'https://www.uvu.edu/thenoorda',
      alt: 'UVU The Noorda',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/pre-concert.jpg',
      link: 'https://www.utahsymphony.org/',
      alt: 'Pre-concert Talks',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/Classical-89.jpg',
      link: 'https://www.classical89.org',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/grand-america.jpg',
      link: 'https://www.laurelslc.com/',
      alt: 'Laurel Brasserie and Bar',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/sun-valley.jpg',
      link: 'https://www.sunvalley.com/',
      alt: 'Sun Valley Resort',
      class: 'webFormat',
    },
    {
      image: '/celtic-woman-2022/sponsors/pago.jpg',
      link: 'https://www.pagoslc.com/',
      alt: 'Pago',
      class: 'webFormat',
    },
    // {
    //   image: '/celtic-woman-2022/sponsors/ruth-chris.jpg',
    //   link: 'https://www.ruthschris.com/restaurant-locations/salt-lake-city/',
    //   alt: 'Ruths Chris Steakhouse',
    //   class: 'webFormat',
    // },
    {
      image: '/celtic-woman-2022/sponsors/ufs-2.jpg',
      link: 'https://utahfoodservices.com/',
      alt: 'Utah Food Services',
      class: 'webFormat',
    },
    // {
    //   image: '/celtic-woman-2022/sponsors/volunteer.jpg',
    //   link: 'https://www.utahsymphony.org/support/volunteer',
    //   alt: 'Utah Symphony Volunteer information',
    //   class: 'webFormat',
    // },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
